export const SKILLS_EVALUATIONS = "/api/folders/:param/skills-evaluations"
export const SKILLS_EVALUATION = "/api/folders/:param/skills-evaluations/:skillsEvaluationFolderParam"

export const GENERATE_GLOBAL_RESULT = "/api/folders/:param/skills-evaluations/:lang/generate"

export const SKILLS_EVALUATION_DEACTIVATE = "/api/folders/:param/skills-evaluations/:skillsEvaluationFolderParam/deactivate"
export const SKILLS_EVALUATION_ACTIVATE = "/api/folders/:param/skills-evaluations/:skillsEvaluationFolderParam/activate"
